import { render } from "./AdminInfraestructura.vue?vue&type=template&id=28083856&scoped=true"
import script from "./AdminInfraestructura.vue?vue&type=script&lang=js"
export * from "./AdminInfraestructura.vue?vue&type=script&lang=js"

import "./AdminInfraestructura.vue?vue&type=style&index=0&id=28083856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28083856"]])

export default __exports__